import { createFileRoute, redirect } from '@tanstack/react-router';
import { AxiosError } from 'axios';

import { getUserQueryOptions } from '@praetoid/client';

export const Route = createFileRoute('/_onboarding')({
	beforeLoad: async ({ context }) => {
		const { queryClient } = context;

		try {
			await queryClient.ensureQueryData(getUserQueryOptions({ query: { retry: false } }));
		} catch (error) {
			if (error instanceof AxiosError) {
				if (error.response?.status === 401) {
					throw redirect({ to: '/signin' });
				}
			}
		}
	}
});
